// История записи из общего аудит-лога. Один клиент на все сущности.
import { apiGet, apiPost } from '../../../shared/api-client/index.js';
import { entityListKey, type EntityListKey } from '../../../shared/api/entityQueryKeys.js';

export type ActivityEntity =
  | 'deal'
  | 'contact'
  | 'company'
  | 'task'
  | 'note'
  | 'meeting'
  | 'document'
  | 'project'
  | 'template';

export interface ActivityItem {
  id: string;
  kind: string;
  actor: string;
  subject?: string | null;
  payload?: Record<string, unknown> | null;
  createdAt: string;
  occurredAt?: string | null;
}

export interface LogActivityInput {
  kind?: 'email_sent' | 'call_logged' | 'meeting_held' | 'note_added' | 'custom';
  subject: string;
  dealId?: string;
  contactId?: string;
  companyId?: string;
  projectId?: string;
  taskId?: string;
  payload?: Record<string, unknown>;
}

export function getEntityActivitiesQueryKey(
  workspaceId: string,
  entity: ActivityEntity,
  entityId: string,
): EntityListKey {
  return entityListKey('activities', workspaceId, { entity, entityId });
}

export async function listEntityActivities(
  entity: ActivityEntity,
  entityId: string,
): Promise<ActivityItem[]> {
  const search = new URLSearchParams({ entity, id: entityId });
  return apiGet<ActivityItem[]>(`/activities?${search.toString()}`);
}

export async function logActivity(input: LogActivityInput): Promise<{ success: true; id: string }> {
  return apiPost<{ success: true; id: string }>('/activities/log', input);
}
